import Clipboard from 'clipboard';

export default function businessCardCopy() {
    const copyButtons = document.querySelectorAll('.js-copy-btn');

    if (!copyButtons) {
        return;
    }

    copyButtons.forEach((element) => {
        // eslint-disable-next-line no-new
        new Clipboard(element);
    });
}
window.addEventListener('load', businessCardCopy);
